/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Mk_Foot_CopyrightInputs */

const en_mk_foot_copyright = /** @type {(inputs: Mk_Foot_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Bystep. Step by step.`)
};

const id_mk_foot_copyright = /** @type {(inputs: Mk_Foot_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Bystep. Selangkah demi selangkah.`)
};

/**
* | output |
* | --- |
* | "© {year} Bystep. Step by step." |
*
* @param {Mk_Foot_CopyrightInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_copyright = /** @type {((inputs: Mk_Foot_CopyrightInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_CopyrightInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_copyright(inputs)
	return en_mk_foot_copyright(inputs)
});